import { FC, useCallback, useEffect, useState } from 'react'
import { IframeApp } from '../IframeApp'
import { RemoteAppProps } from '../types'

let firstLoad = true
export const ReloadProtectedApp: FC<RemoteAppProps> = ({ src, name, id }) => {
  const [key, setKey] = useState(0)

  const handleLoad = useCallback(() => {
    if (firstLoad) {
      firstLoad = false
      return
    }
    setKey((prev) => prev + 1)
    firstLoad = true
  }, [])

  useEffect(() => {
    firstLoad = true
  }, [src])

  return (
    <IframeApp key={key} id={id} src={src} name={name} onLoad={handleLoad} />
  )
}
